var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 8,
    viewBox: "0 0 17 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3998 4.56842C15.3643 4.60888 15.3257 4.64303 15.2852 4.67273L12.5722 7.77312C12.3075 8.07546 11.8781 8.0756 11.6134 7.77298C11.3486 7.4705 11.3486 6.97991 11.6134 6.67715L13.9498 4.00694L11.6013 1.32281C11.3365 1.02034 11.3365 0.529889 11.6013 0.226981C11.7338 0.075456 11.9074 -1.93292e-05 12.0807 -1.93292e-05C12.2539 -1.93292e-05 12.4277 0.075456 12.56 0.226981L15.2852 3.34172C15.3257 3.37142 15.3645 3.40557 15.3998 3.44604C15.5351 3.60072 15.6004 3.80448 15.5972 4.00723C15.6004 4.20998 15.5351 4.41359 15.3998 4.56842Z",
    fill: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 10,
    height: 2,
    rx: 1,
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 8,
    fill: "white",
    transform: "matrix(-1 0 0 -1 17 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4666c0e9def05101b224defc4fd90c27.svg";
export { ForwardRef as ReactComponent };